import styled from 'styled-components'
import { Slider } from 'antd'
import { greys } from 'assets/themes/theme-default'

import { calculateAlphaColor } from 'core/utils/colors'

const AntSliderStyled = styled(Slider)`
  &&& {
    .ant-slider-rail {
      background-color: ${calculateAlphaColor(greys.dark3, 0.35)};
    }

    .ant-slider-dot {
      border-color: ${greys.dark3};
    }
    .ant-slider-handle {
      border-color: ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.8)};
      height: 18px;
      width: 18px;
      margin-top:-8px;

        box-shadow: 0 0 0 3px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.8)};
      }
    }
    .ant-slider-track {
      background-color: ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
    }
    :hover{
      .ant-slider-track{
        background-color: ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
    }
  }
`

export default AntSliderStyled
